<template>
  <div id='tamilConsentForm' class="section content">
    <!-- <div class="box"> -->
    <h1 class="title has-text-centered"> ஒப்புதல் படிவம் </h1>
    <h4 class="has-text-centered"><b>NIHR மனநோய் உலக சுகாதார ஆராய்ச்சி குழு : வார்விக் -இந்தியா -கனடா  (WIC) நெட்ஒர்க் </b></h4>
    <ol>
      <li>
        <p>
              நான் இந்த <a href="/participation-info-tamil"> ஆராய்ச்சியில் பங்கு பெறுவதற்கான ஒப்புதல் </a> படிவத்தை நன்றாக புரிந்து கொண்டேன். நான் கேட்ட கேள்விகளுக்கு அவர்கள் அளித்த பதில்கள் எனக்கு திருப்திகரமாக இருந்தது.
        </p>
      </li>
	  <li>
        <p>
              நான் என்னுடைய சுய விருப்பத்தில்; பங்கு பெறுகிறேன் மற்றும் எந்த நேரத்திலும் எந்த விதமான முன் அறிவிப்பின்றி  இந்த ஆராய்ச்சியிலிருந்து விலகி கொள்ளலாம் என்று புரிந்து  கொண்டேன்.
	    </p>
      </li>
	  <li>
        <p>
              நான் ஆராய்ச்சியில் பங்கு பெறுவதற்கும் கேள்வி மற்றும் பேட்டியில் கலந்து கொள்வதற்கும் ஒப்புதல் அளிக்கின்றேன்.
        </p>
      </li>
      <li>
        <p>
              என்னை பற்றி சேகரிக்கபட்ட தகவல்களை இறுதி அறிக்கை மூலம் வெளியிட நான் சம்மதிக்கிறேன் (இது ரகசியமாக உங்கள் பற்றின விவரங்கள் தெரியாமல் பாதுகாக்கப்படும்).
        </p>
      </li>
      <li>
        <p>
              எதிர்காலத்தில் உங்களை தொடர்பு கொள்ள இந்த மதீப்பீடு உதவியாக இருக்கும் என்று புரிந்து கொண்டேன்.
        </p>
      </li>
      <li>
        <p>
              ஆராய்ச்சியின் நோக்கங்களுக்காக என்னுடைய மருத்துவ தகவல்களை ஆராய்ச்சியாளர்கள் அணுகுவதற்கு நான் சம்மதம் அளிக்கிறேன். என்னுடைய தகவல்கள் அனைத்தையும் ஆராய்ச்சியாளர்கள் மிகவும் நம்பகத்தன்மையும் பகுப்பாய்வு செய்வார்கள் என்று புரிந்து கொண்டேன்.
        </p>
      </li>
	  <li>
        <p>
              இந்த ஆராய்ச்சியில் பங்கு பெற ஒப்புதல் அளிக்கிறேன்.
	    </p>
      </li>
	  <li>
        <p>
              என்னால் கொடுக்கப்பட்ட விவரங்கள் அனைத்தும் பரிந்துரைக்கப்பட்ட நபரால் இந்த ஆராய்ச்சி முடியும் வரை உதவி புரிய சம்மதிக்கிறேள்.
	    </p>
      </li>
    </ol>
    <input type="checkbox" class="is-large" id="checkbox" v-model="agreed" :disabled="disagreed === true">
    <label for="checkbox" class="is-size-5">&nbsp; நான் ஒப்புக்கொள்கிறேன்</label><br>
    <input type="checkbox" class="is-large" id="checkbox" v-model="disagreed" :disabled="agreed === true">
    <label for="checkbox" class="is-size-5">&nbsp; நான்  ஒப்புகொள்ளமறுக்கிறேன்</label>
    <br>
    <br>
    <div class="has-text-centered" v-if="agreed">
      <button class="button is-large is-info" @click="next()">Next &gt;&gt;</button>
    </div>
    <div class="has-text-centered" v-if="disagreed">
      <div class="control control">
        <input class="input" type="text" v-model='reasonForDecline' placeholder='Please type in reason for disagreeing' :disabled="isFeedbackSend">
      </div>
      <br>
      <button class="button is-large is-danger" @click="decline()" :disabled="isFeedbackSend">&lt;&lt; Decline</button>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>

export default {
  name: 'tamilConsentForm',
  data() {
    return {
      title: 'Consent Form',
      agreed: false,
      disagreed: false,
      reasonForDecline: '',
      declineMsg: 'Thanks for your feedback.',
      isFeedbackSend: false,
    };
  },
  methods: {
    next() {
      if (this.agreed) {
        this.$router.push('demographics/tamil');
      }
    },
    decline() {
      if (this.reasonForDecline === '') {
        this.$toast.open('Please provide reason for disagreeing');
        return;
      }
      this.$http.post('/scarf/declineTest', {
        sessionId: this.$temp.sessionCode,
        reason: this.reasonForDecline,
      })
        .then((res) => {
          if (res.data.ok === 1) {
            this.$toast.open(this.declineMsg);
            this.isFeedbackSend = true;
          }
        });
    },
  },
  created() {
    window.scroll(0, 0);
    console.log('general info created');
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TamilConsentForm.vue